import { type UserI } from "presentation/store/model/user"
import { type VolunteerLevel } from "presentation/store/model/volunteer"
import { type CertificateData } from "./model"
import { normalizeCertificateText } from "./text"

export function buildCertificateData (
    profile: UserI,
    levels: VolunteerLevel[],
    now = new Date()
): CertificateData {
    // Match the ordinal shown by ProfileMyGrade, rather than the level's database ID/order.
    const levelIndex = levels.findIndex(level => level.id === profile.user.volunteerLevelId)
    const levelName = normalizeCertificateText(levels[levelIndex]?.name || "")
    if (!profile.user.volunteerLevelId || !levelName || levelIndex < 0 || levelIndex > 5) {
        throw new Error("Для формирования сертификата необходим текущий уровень волонтёра.")
    }

    const lastName = normalizeCertificateText(profile.fio.last_name || "")
    const firstName = normalizeCertificateText(profile.fio.first_name || "")
    const patronymic = normalizeCertificateText(profile.fio.second_name || "")
    if (!lastName || !firstName) {
        throw new Error("Для сертификата необходимо указать имя и фамилию в профиле.")
    }
    const volunteerId = profile.user.volunteerId
    if (!Number.isSafeInteger(volunteerId) || volunteerId <= 0) {
        throw new Error("Не удалось получить ID волонтёра на добро.рф.")
    }
    const verifiedHours = profile.statistics.verifiedHours
    if (!Number.isFinite(verifiedHours) || verifiedHours < 0) {
        throw new Error("Не удалось получить количество часов волонтёрства.")
    }
    if (!Array.isArray(profile.courses)) {
        throw new Error("Не удалось получить количество пройденных курсов.")
    }
    const year = now.getFullYear()
    if (!Number.isInteger(year) || year < 1000 || year > 9999) {
        throw new Error("Не удалось определить год формирования сертификата.")
    }

    return {
        lastName,
        givenNames: [firstName, patronymic].filter(Boolean).join(" "),
        levelName,
        courseCount: profile.courses.length,
        verifiedHours,
        certificateNumber: `${volunteerId}-${levelIndex + 1}`,
        year,
    }
}
